<template>
  <b-modal
    :visible="value"
    @change="$emit('input', $event)"
    @hide="$emit('input', false)"
    title="Add Social Learning"
    hide-footer
    size="lg"
    centered
  >
    <div class="form-group">
      <div class="row">
        <div class="col-12">
          <label class="form-label"
            >Competency
            <span class="text-danger"
              >(* Proficiency level is below standard)</span
            ></label
          >
          <v-select
            v-model="bodyAdd.competency"
            :options="dataCompetency"
            label="competency"
            :reduce="(e) => e.competency_id"
            placeholder="Select Competency"
          />
        </div>
        <div class="col-12 mt-3">
          <label class="form-label">Coaching/Mentoring</label>
          <v-select
            v-model="bodyAdd.coaching"
            :options="dataCoaching"
            label="coaching_title"
            :reduce="(e) => e.coaching_id"
            placeholder="Select Coaching/Mentoring"
          />
        </div>
      </div>
    </div>
    <b-button
      class="float-end"
      variant="primary"
      @click="createCoaching()"
      :disabled="isCreatingCoaching"
    >
      <template v-if="isCreatingCoaching">
        <b-spinner small></b-spinner>
        Mengirim...
      </template>
      <template v-else> Submit </template>
    </b-button>
  </b-modal>
</template>

<script>
import { fetchSubmitTNASocial } from "../api";

export default {
  name: "AddSocialModal",
  props: {
    value: Boolean,
  },

  data() {
    return {
      isCreatingCoaching: false,
      bodyAdd: {
        competency: null,
        coaching: null,
      },
      dataCompetency: [],
      dataCoaching: [],
    };
  },

  watch: {
    "bodyAdd.competency"(val) {
      if (val) {
        this.getCoaching(val);
      } else {
        this.dataCoaching = [];
      }
    },
  },

  methods: {
    getCompetency() {
      this.$store.dispatch("competency/getDataCompetencyByNik").then((res) => {
        this.dataCompetency = res.data;
      });
    },

    getCoaching(val) {
      if (!val) return;

      this.$store
        .dispatch("coaching/getCoachingByCompetency", {
          competencyId: val,
        })
        .then((res) => {
          this.dataCoaching = res.data.map((item) => ({
            coaching_id: item.id,
            coaching_title: item.title,
            coach_name: item.coach_name,
            type: item.type,
            type_name: item.type_name,
            hour: item.hour,
            cover_image: item.cover_image,
          }));
        });
    },

    async createCoaching() {
      // muncul dialog confirm dulu
      const result = await this.$swal.fire({
        title: "Submit Social Learning?",
        text: "Pastikan data sudah sesuai sebelum dikirim.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, kirim",
        cancelButtonText: "Batal",
        reverseButtons: true,
      });

      // kalau cancel → berhenti
      if (!result.isConfirmed) return;

      this.isCreatingCoaching = true;

      try {
        const payload = {
          competency_id: this.bodyAdd.competency,
          coaching_id: this.bodyAdd.coaching,
        };
        const res = await fetchSubmitTNASocial(payload);

        await this.$swal.fire({
          icon: "success",
          title: "Success",
          text: "Social Learning berhasil ditambahkan.",
        });

        // tutup modal
        this.$emit("input", false);

        // clear form (optional)
        this.bodyAdd = {
          competency: null,
          coaching: null,
        };
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Gagal submit Social Learning.",
        });
      } finally {
        this.isCreatingCoaching = false;
      }
    },
  },

  mounted() {
    this.getCompetency();
  },
};
</script>
